<div popper [validate]="formControl">
  <files-input [disabled]="disabled"
               [config]="config"
               [single]="single"
               [accepted]="accepted"
               [ngModel]="value"
               (ngModelChange)="change($event)">
  </files-input>
</div>
